import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

/**
 * SettingsContext — publicly-readable site feature flags fetched once on boot.
 * Currently gates:
 *  - founder_club_visible: shows/hides the /founder-club route + banner CTA
 */
const SettingsContext = createContext({
  flags: { founder_club_visible: true },
  refresh: async () => {},
});

export function SettingsProvider({ children }) {
  const [flags, setFlags] = useState({ founder_club_visible: true });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/feature-flags");
      setFlags((prev) => ({ ...prev, ...data }));
    } catch { /* keep defaults if the API is transiently down */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SettingsContext.Provider value={{ flags, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
